module.exports = __webpack_public_path__ + "img/default_img.ef6e9b05.png";